import { useCallback, useEffect, useState } from 'react'

import { userGroupServices } from '../services/userGroupServices';

import useErrorHandler from './useErrorHandler';

function useUserGroup(filters = {}, dependency = []) {
    const { errorHandler } = useErrorHandler();

    const [userGroupList, setUserGroupList] = useState([]);
    const [rowCount, setRowCount] = useState(0);

    const getAllGroup = useCallback(async (currentFilters) => {
        try {
            const res = await userGroupServices.getAllGroup(currentFilters);
            console.log("getAllGroup => ", res);
            if (res.status === 200) {
                setUserGroupList(res.data.data);
                setRowCount(res.data.rowCount);
            }
        } catch (error) {
            console.log(error);
            errorHandler('error: getAllGroup', error.response.status);
        }
    }, []);

    useEffect(() => {
        getAllGroup(filters);
    }, dependency);

    return { userGroupList, rowCount };
}

export default useUserGroup